export default "__VITE_ASSET__0d04d9ea__"